export default {"src":"/_next/static/media/ico_zoom.e4cdedff.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};